import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const Splash = () => (
  <div className="min-h-screen flex items-center justify-center bg-stone-50">
    <Loader2 className="h-8 w-8 animate-spin text-emerald-600" data-testid="auth-loading" />
  </div>
);

export const ProtectedRoute = ({ children, role }) => {
  const { user, ready } = useAuth();
  if (!ready) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/mr"} replace />;
  }
  return children;
};
